export default __webpack_public_path__ + "static/fbc-e922efb5ea0735506bdce27245a63796.png";